import React, { useState } from "react";
import Footer from "../../components/Footer_/Footer";
import AboutSec from "../../components/AboutSec_/AboutSec";
import CommonHero from "../../components/CommonHero_/CommonHero";
// import Services from "../../components/Services_/Services";
import { Helmet } from "react-helmet";
// import Header from "../../components/Header_/Header";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Col, Container, Row, Spinner } from "react-bootstrap";
import formstyles from "./ContactScreen.module.css";
import CallToAction from "../../components/CallToAction/CallToAction";

const BatteryTechnology = () => {
   const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [phoneNum, setPhoneNum] = useState("");
    const [message, setMessage] = useState("");
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);
  
    const history = useNavigate();
  
    const formSubmitHandler = (event) => {
      event.preventDefault();
      setLoading(true);
      axios
        .post("/send-contact-form", {
          name,
          email,
          phoneNumber: phoneNum,
          message,
        })
        .then((response) => {
          if (response.data.msg === "success") {
            setError(false);
            setSuccess("Form Submitted Successfully!");
            setLoading(false);
            setEmail("");
            history("/thank-you");
          } else if (response.data.msg === "fail") {
            setSuccess(false);
            setError("Email failed to send, try again by reloading the page.");
            setLoading(false);
            setEmail("");
          }
        });
    };
  return (
    <>
      <Helmet>
        <title>Licensed Electrical Services in Southern Ontario | TRU Electrical</title>
        <meta name="keywords" content="Licensed Electrical Services in Southern Ontario" />
        <link
          rel="canonical"
          href="https://www.truoffgrid.com/tru-electrical-services"
        />
        <meta
          name="description"
          content="Reliable residential & commercial electrical services in Southern Ontario. ESA-certified, solar tie-ins, backup power & panel upgrades. Call 289-981-7825 today!"
        />
      </Helmet>
      {/* <CommonHero
        // image={"/images/hero-batterytechnology.jpg"}
        heading="BATTERY TECHNOLOGY"
      /> */}
       <CommonHero
        shopHero={true}
        heading="TRU Electrical Services"
      />
      {/* <AboutSec
        heading={"TRU Electrical Services"}
        subHeading={""}    
        text={`
          Our TRU Electrical Services division provides commercial electrical and residential electrical services in Southern Ontario.
          <br/> <br/>
          We carry a Master Electrician License, issued by the Electrical Safety Authority (ESA).
          <br/> <br/>
          Scope of Expertise and Projects we Tackle:
 <br/> <br/>
• AC Interconnection (or Grid-Tie Integration) for Solar Projects <br/>
• Point of Connection: Connecting the solar inverter to a sub-panel or main electrical panel including Supply-Side Connection (if connected before the main breaker) or a Load-Side Connection (if connected via a breaker inside the panel).<br/>
• Permitting:  Pursuing ESA Electrical Notification (commonly called an electrical permit) under the "Renewable Energy" or "Solar PV". <br/>
• Three-Phase Power Distribution: Installing and maintaining 120/208V and 347/600V distribution systems, switchgear, and step-down transformers.  <br/>
• Tenant Improvements & Fit-Outs: Retrofitting office buildings, retail spaces, and restaurants with customized power layouts, specialized HVAC connections, and dedicated equipment circuits. <br/>
• Commercial Lighting Automation: Programming and wiring energy-efficient LED retrofits, daylight harvesting systems, and automated building management system (BMS) controls.   <br/>
• Emergency Power Systems: Integrating automatic transfer switches (ATS) linked to backup diesel or gas commercial generators.   
<br/> <br/>
<b>Please call Jack Abrams, Owner TRU Electrical Services - a division of TRU Off Grid <a href="tel:905 299 7841">905 299 7841</a> or <a href="mailto:sales@truoffgrid.com">email sales@truoffgrid.com</a> </b>
`}
        img={"/images/tru-electrical-servies.png"}
        cta={false}
      /> */}

      {/* <AboutSec
        heading={"Be Aware Of What You Buy"}
        text={`There are many cheap, poor quality, foreign owned companies selling LFP batteries and these companies cut corners on quality assurance, components, safety, quality testing and certification. Price is important but not at the cost of reduced safety for your family. Please review this article by Transport Canada <a target="no_blank" href="https://tc.canada.ca/en/dangerous-goods/safety-advisories/lithium-batteries-be-aware-what-you-buy">Lithium batteries – Be aware of what you buy</a>`}
        img={"/images/lithium-battery.jpg"}
        reverse={true}
        cta={true}
      /> */}
      {/* <Services /> */}

      {/* <AboutSec
        heading={"LPF - Safety"}
        subHeading={"Safer Than You Think!"}
        text={`LiFePO4 or LFP batteries are the safest type of lithium battery on the market,
        they are highly stable and not prone to overheating. Even if they’re punctured, they
        won’t catch on fire. The cathode material in LiFePO4 is also non-hazardous material
        and therefore it poses no environmental or negative health hazards. LFP is free of rare
        and heavy metals, non-polluting, non-toxic, and in compliance with Canadian
        requirements.`}
        img={"/images/battery2.png"}
        reverse={true}
        cta={true}
      />
      <AboutSec
      heading={"LPF – Why Are They Great?"}
      subHeading={"Best In The Game"}
      text={`Energy capacity and low self-discharge rate: LiFePO4 or LFP batteries can be
      discharged up to 100% without being damaged, they offer a much higher energy capacity than
      lead-acid batteries, which can only be discharged up to 50% of their storage capacity. LFP
        batteries have a lower self-discharge rate compared to some other battery technologies. This
        means they hold their charge longer when not in use, which is handy for applications where 
        power is used intermittently. LFP batteries only lose an average of 3% charge per month of
        inactivity. It is still advisable to unplug them when the expected period of non-use is greater than
        3 months.`}
        img={"/images/battery3.png"}
        cta={true}
      />
      <AboutSec
      heading={"LFP – Additional Benefits"}
        subHeading={"It Doesn’t Get Better!"}
        text={`● Long battery life cycle: LFP batteries have a life-cycle of up to 6,000 cycles
        compared to 300 cycles for long-life lead acid batteries. Theoretically, an LFP
        battery could last for 15 years.<br/><br/>
        ● Performs well at temperatures: LFP batteries perform well at extremes of
        temperature with an operating range of -20C to +75C. Self Heating LFP batteries
        allow for charging in freezing temperatures.<br/><br/>
        ● Lightweight: A LiFePO4 battery weighs one third that of lead-acid batteries.`}
        img={"/images/battery4.png"}
        reverse={true}
        padding="80px 0px 220px 0px"
        cta={true}
        /> */}


      <AboutSec
        heading={"LICENSED ELECTRICAL SERVICES ACROSS SOUTHERN ONTARIO"}
        subHeading={""}
        text={`At TRU Electrical Services, a division of TRU Off Grid, we deliver commercial and residential electrical work across Southern Ontario. We carry a Master Electrician License issued by the Electrical Safety Authority (ESA) and handle everything from solar grid-tie interconnections to three-phase power distribution, tenant fit-outs, lighting automation, and emergency power systems. Please give us a call to discuss how we can help.
          
          <br/><br/> Please reach out to Steve Monteleone, Master Electrician at <a href="tel:289-981-7825">289-981-7825</a> or <a href="mailto:steve@truelectric.ca">steve@truelectric.ca</a>`}
        img={"/images/tru-electrical-servies-logo.jpg"}
        ctaSteve={true}
      />
      <CallToAction ctaSteve={true} />
      <AboutSec
        heading={"SERVICES OFFERED by TRU ELECTRICAL"}
        subHeading={""}
        text={`We carry a Master Electrician License issued by the Electrical Safety Authority (ESA) and can provide:
          <ul class="mt-3">
          <li>AC Interconnection and Grid Tie Integration for Solar Projects</li>
          <li>Point of Connection Wiring Through Supply-Side or Load-Side Connection</li>
          <li>ESA Electrical Permitting</li>
          <li>Three Phase Power Distribution</li>
          <li>Switch Gear and Step-Down Transformers</li>
          <li>Tennant Improvements and Fit-Outs</li>
          <li>Dedicated Equipment Circuits</li>
          <li>Commercial Lighting </li>
          <li>Automation with BMS Controls</li>
          <li>Emergency Power Systems</li>
          <li>Automated Transfer Switches tied to Back Up Generators</li>
          </ul>
          `}
        img={"/images/eg4-gridboss-at-the-meter.jpg"}
        reverse={true}
        ctaSteve={true}
        imgBorderRad={true}
      />
      <AboutSec
        heading={"COMMERCIAL BACKUP POWER: EMERGENCY POWER SYSTEMS"}
        subHeading={""}
        text={`Keep your business running when the grid goes down. TRU Electrical Services integrates automatic transfer switches (ATS) linked to backup diesel or gas commercial generators, so your critical circuits switch over to standby power the moment an outage hits. Backed by our Master Electrician License from the Electrical Safety Authority (ESA), we also handle three-phase power distribution across 120/208V and 347/600V systems, switchgear and step-down transformers, tenant fit-outs with dedicated equipment circuits, and energy-efficient lighting automation with BMS controls. Contact us today to design a backup power setup around your facility.`}
        img={"/images/backup-power-eg4-12000xp-on-battery.jpg"}
        ctaSteve={true}
        imgBorderRad={true}
      />
      <AboutSec
        heading={"ESA-CERTIFIED ELECTRICAL WORK"}
        subHeading={"LICENSED & COMPLIANT"}
        text={`Every job TRU Electrical Services touches is backed by a Master Electrician License issued by the Electrical Safety Authority (ESA). For solar projects, we file the ESA Electrical Notification and the electrical permit under the Renewable Energy or Solar PV category so your system is inspected, approved, and fully code-compliant. From supply-side and load-side interconnections to three-phase distribution and emergency power systems, licensed and permitted work protects your property, your warranty, and your peace of mind.`}
        img={"/images/esa-certified-work-eg4-12000xp-and-conduit.jpg"}
        reverse={true}
        ctaSteve={true}
        imgBorderRad={true}
      />


    <div
        style={{ padding: "80px 0px 80px 0px" }}
        className="main text-center"
      >
        <Container>
          <Row className="gy-4 gx-5">
            <Col lg={6}>
              <div className={formstyles.contentCol}>
                <h3 className="h2_main pb-2">Contact us</h3>
                <h2 className="h1_main pb-4">
                  NEED HELP WITH YOUR RESIDENTIAL or COMMERCIAL ELECTRICAL PROJECT? <span>Lets Talk</span>
                </h2>
                <Row>
                  <Col className="pt-3" lg={12}>
                    <a
                      style={{ textDecoration: "none" }}
                      href="tel: 289-981-7825"
                    >
                      <div className={formstyles.info}>
                        <img src="/images/phone.svg" alt="icon" />
                        {/* <p className="para_main">905-299-7841</p> */}
                        <p className="para_main">289-981-7825</p>
                      </div>
                    </a>
                  </Col>
                  <Col className="pt-3" lg={12}>
                    <a
                      style={{ textDecoration: "none" }}
                      href="mailto: steve@truelectric.ca"
                    >
                      <div className={formstyles.info}>
                        <img src="/images/mail.svg" alt="icon" />
                        <p className="para_main">steve@truelectric.ca</p>
                      </div>
                    </a>
                  </Col>
                  <Col className="pt-3" lg={12}>
                    <a
                      style={{ textDecoration: "none" }}
                      target="no_blank"
                      href="https://www.google.com/maps/dir//TRU+Off+Grid+-+Solar+%26+Energy+Storage,+348+Bronte+St.+S+Unit+21,+Milton,+ON+L9T+5B6/@43.5108146,-79.963851,12z/data=!4m8!4m7!1m0!1m5!1m1!1s0x267e0b12cb8a4ddf:0xae5c0834e6f5863a!2m2!1d-79.8791121!2d43.4996211?entry=ttu&g_ep=EgoyMDI2MTAxMy4wIKXMDSoASAFQAw%3D%3D"
                    >
                      <div className={formstyles.info}>
                        <img src="/images/location.svg" 
alt="icon"/>
                        <p className="para_main">
                          348 Bronte St., South Unit #21 Milton, ON (Please give
                          us a call, send an email or complete the Let's Get in
                          Touch form. Thanks)
                        </p>
                      </div>
                    </a>
                  </Col>
                </Row>
              </div>
            </Col>
            
            <Col lg={6}>
              <div className={formstyles.formCol}>
                <h2 className="h1_main pb-2">Let’s get in touch!</h2>
                <p className="para_main pb-5">
                  Lets discuss your project and find out what we can do
                </p>
                {loading ? (
                  <div className="row pb-4">
                    <div className="col-12">
                      <Spinner
                        animation="border"
                        role="status"
                        style={{ color: "black" }}
                      />
                    </div>
                  </div>
                ) : success ? (
                  <div className="row pb-4">
                    <div className="col-12">
                      <p className="para_main" style={{ color: "black" }}>
                        {success}
                      </p>
                    </div>
                  </div>
                ) : (
                  error && (
                    <div className="row pb-4">
                      <div className="col-12">
                        <p className="para_main" style={{ color: "black" }}>
                          {error}
                        </p>
                      </div>
                    </div>
                  )
                )}
                <form onSubmit={formSubmitHandler}>
                  <input
                    maxLength="12"
                    type="text"
                    placeholder="Your Full Name"
                    pattern=".{3,}"
                    required
                    value={name}
                    onChange={(event) => setName(event.target.value)}
                  />
                  <input
                    maxLength="36"
                    type="email"
                    placeholder="Email"
                    pattern=".{3,}"
                    required
                    value={email}
                    onChange={(event) => setEmail(event.target.value)}
                  />
                  <input
                    maxLength="36"
                    type="text"
                    placeholder="Phone Number"
                    pattern=".{3,}"
                    required
                    value={phoneNum}
                    onChange={(event) => setPhoneNum(event.target.value)}
                  />
                  <input
                    style={{ resize: "none" }}
                    as="textarea"
                    maxLength="800"
                    type="text"
                    placeholder="Your Message"
                    required
                    value={message}
                    onChange={(event) => setMessage(event.target.value)}
                  />
                  <button className="button_main mt-3" type="submit">
                    Submit
                  </button>
                </form>
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      
        <div className="py-5 my-4"></div>
      <Footer newsletter={true} />
    </>
  );
};

export default BatteryTechnology;
